<app-header-view
  [showNavbar]="showNavbar()"
  [showGameScore]="showGameScore()"
  [showGameReplay]="showGameReplay()"
  [navbarTemplate]="navbar"
  [gameId]="gameId"
  [gameScoreName]="gameScoreService.gameName()"
  [isLocal]="isLocalGame()"
  [displayGameInterfaceState]="displayGameInterfaceState()"
  [gameInterfaceState]="gameScoreService.gameInterfaceState()"
  [score]="gameScoreService.score()"
  [reward]="gameScoreService.formattedReward()"
  [countdown]="gameScoreService.countdown()"
  [match]="gameScoreService.match()"
  [soloTarget]="gameScoreService.soloTarget()"
  [soloPrize]="gameScoreService.soloPrize()"
  [roomId]="gameScoreService.roomId()"
  (backClickedEvent)="onBackClicked()"
  (closeClickedEvent)="onGameScoreCloseClicked()"
  (cheatSheetClickedEvent)="onCheatSheetClicked()"
  (closeReplayClickedEvent)="onCloseReplayClicked()"
/>
<ng-template #navbar>
  <app-navbar
    [gameName]="gameName"
    [gameId]="gameId"
    [tabs]="tabs"
    [balance]="balance"
    (closeClicked)="onCloseClicked()"
    (tabSelected)="onTabSelected($event)"
  />
</ng-template>
